import { apiFetch } from './prospects';

export function fetchEnterprises() {
  return apiFetch('/enterprises');
}

export function fetchEnterprise(enterpriseId) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}`);
}

export function createEnterprise(payload) {
  return apiFetch('/enterprises', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function fetchEnterpriseMembers(enterpriseId) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/members`);
}

export function inviteEnterpriseMember(enterpriseId, payload) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/members`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function updateEnterpriseMember(enterpriseId, memberId, payload) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/members/${encodeURIComponent(memberId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }
  );
}

export function fetchEnterpriseRoles(enterpriseId) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/roles`);
}

export function createEnterpriseRole(enterpriseId, payload) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/roles`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function updateEnterpriseRole(enterpriseId, roleId, payload) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/roles/${encodeURIComponent(roleId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }
  );
}

export function deleteEnterpriseRole(enterpriseId, roleId) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/roles/${encodeURIComponent(roleId)}`,
    { method: 'DELETE' }
  );
}

export function fetchEnterpriseApiKeys(enterpriseId) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/api-keys`);
}

export function createEnterpriseApiKey(enterpriseId, payload) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/api-keys`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function revokeEnterpriseApiKey(enterpriseId, keyId) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/api-keys/${encodeURIComponent(keyId)}`,
    { method: 'DELETE' },
  );
}

/** JSON mcpServers (MCP HTTP distant + clé API). Crée une clé si apiKey absent. */
export function fetchEnterpriseMcpImportBundle(enterpriseId, payload = {}) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}/mcp/import-bundle`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function fetchEnterpriseMemberHubupQr(enterpriseId, memberId) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/members/${encodeURIComponent(memberId)}/hubup-qr`,
  );
}

export function removeEnterpriseMember(enterpriseId, memberId) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/members/${encodeURIComponent(memberId)}`,
    {
      method: 'DELETE',
    }
  );
}

export function patchEnterprise(enterpriseId, payload) {
  return apiFetch(`/enterprises/${encodeURIComponent(enterpriseId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function fetchHubupCommunitiesForEnterpriseAssign() {
  return apiFetch('/enterprises/hubup-communities');
}

export function fetchEnterpriseStancerConfiguration(enterpriseId) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/configuration/stancer`
  );
}

export function updateEnterpriseStancerConfiguration(enterpriseId, payload) {
  return apiFetch(
    `/enterprises/${encodeURIComponent(enterpriseId)}/configuration/stancer`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }
  );
}
